import { ChartJS } from "chart.js/auto";
import i18next, { t } from "i18next";
import React from "react";
import { Bar, Chart } from "react-chartjs-2";
import { getNextMonths } from "../utils/date";

const barColors = ["#c40606", "#ffc266", "#6cbb6c", "#419741"];

const labels = getNextMonths(4);

const text = [
  t("personal_plan.beginner"),
  t("personal_plan.confident"),
  t("personal_plan.freelancer"),
];

const PersonalPlanChart = ({ barValues }) => {
  const horizontalDottedLine = {
    id: "horizontalDottedLine",
    beforeDraw(chart) {
      const { ctx, chartArea, scales } = chart;

      const { width } = chartArea;
      const { x, y } = scales;
      ctx.save();

      ctx.fillStyle = "#989898";
      ctx.textAlign = "center";
      ctx.font = "normal 10px Open Sans";
      ctx.fillText("0", x.getPixelForValue(0) - 32, y.getPixelForValue(0) - 3);

      ctx.strokeStyle = "#989898";
      ctx.lineWidth = 1;
      ctx.strokeRect(
        x.getPixelForValue(0) - 35,
        y.getPixelForValue(0),
        width,
        0
      );

      ctx.strokeStyle = "#989898";
      ctx.lineWidth = 1;
      ctx.setLineDash([5, 15]);
      ctx.strokeRect(
        x.getPixelForValue(0) - 35,
        y.getPixelForValue(50),
        width,
        0
      );

      ctx.fillStyle = "#989898";
      ctx.textAlign = "center";
      ctx.font = "normal 10px Open Sans";
      ctx.fillText(
        "50%",
        x.getPixelForValue(0) - 25,
        y.getPixelForValue(50) - 3
      );

      ctx.strokeStyle = "#989898";
      ctx.lineWidth = 1;
      ctx.setLineDash([5, 15]);
      ctx.strokeRect(
        x.getPixelForValue(0) - 35,
        y.getPixelForValue(100),
        width,
        0
      );

      ctx.fillStyle = "#989898";
      ctx.textAlign = "center";
      ctx.font = "normal 10px Open Sans";
      ctx.fillText(
        "100%",
        x.getPixelForValue(0) - 23,
        y.getPixelForValue(100) - 3
      );

      ctx.restore();
    },
  };

  const data = {
    labels: labels,
    datasets: [
      {
        data: barValues,
        backgroundColor: barColors,
        borderColor: "transparent",
        borderRadius: {
          topLeft: 3,
          topRight: 3,
          bottomLeft: 3,
          bottomRight: 3,
        },
        borderSkipped: false,
        barThickness: 30,
      },
    ],
  };

  const options = {
    responsive: true,
    events: [],
    animation: {
      duration: 2000,
      onComplete: function (props) {
        if (props.currentStep > 0) {
          const bars = props.chart.getDatasetMeta(0).data;
          const first = bars[0];
          props.chart.ctx.beginPath();
          i18next.language === "en"
            ? props.chart.ctx.roundRect(first.x - 35, first.y - 29, 70, 18, 2)
            : i18next.language === "pt"
            ? props.chart.ctx.roundRect(first.x - 35, first.y - 29, 70, 18, 2)
            : props.chart.ctx.roundRect(first.x - 37, first.y - 29, 75, 18, 2);
          props.chart.ctx.fillStyle = "#474747";
          props.chart.ctx.strokeStyle = "#474747";
          i18next.language === "en"
            ? props.chart.ctx.fillRect(first.x - 35, first.y - 29, 70, 18)
            : i18next.language === "pt"
            ? props.chart.ctx.fillRect(first.x - 37, first.y - 29, 75, 18)
            : props.chart.ctx.fillRect(first.x - 37, first.y - 29, 75, 18);

          props.chart.ctx.stroke();

          props.chart.ctx.beginPath();
          props.chart.ctx.moveTo(first.x, first.y - 5);
          props.chart.ctx.lineTo(first.x + 5, first.y - 10);
          props.chart.ctx.lineTo(first.x - 5, first.y - 10);
          props.chart.ctx.lineTo(first.x, first.y - 5);
          props.chart.ctx.fillStyle = "#474747";
          props.chart.ctx.strokeStyle = "#474747";
          props.chart.ctx.fill();
          props.chart.ctx.stroke();

          props.chart.ctx.fillStyle = "#ffffff";

          i18next.language === "en"
            ? (props.chart.ctx.font = "normal 13px Open Sans")
            : (props.chart.ctx.font = "normal 12px Open Sans");
          i18next.language === "en"
            ? props.chart.ctx.fillText(text[0], first.x - 27, first.y - 16)
            : i18next.language === "de"
            ? props.chart.ctx.fillText(text[0], first.x - 25, first.y - 16)
            : i18next.language === "pt"
            ? props.chart.ctx.fillText(text[0], first.x - 22, first.y - 16)
            : props.chart.ctx.fillText(text[0], first.x - 32, first.y - 16);

          const third = bars[2];

          i18next.language === "de"
            ? props.chart.ctx.roundRect(third.x - 45, third.y - 40, 85, 30, 2)
            : props.chart.ctx.roundRect(third.x - 40, third.y - 40, 80, 30, 2);
          props.chart.ctx.fillStyle = "#474747";
          props.chart.ctx.strokeStyle = "#474747";

          i18next.language === "de"
            ? props.chart.ctx.fillRect(third.x - 45, third.y - 40, 85, 30)
            : props.chart.ctx.fillRect(third.x - 40, third.y - 40, 80, 30);
          props.chart.ctx.stroke();

          props.chart.ctx.beginPath();
          props.chart.ctx.moveTo(third.x, third.y - 5);
          props.chart.ctx.lineTo(third.x + 5, third.y - 10);
          props.chart.ctx.lineTo(third.x - 5, third.y - 10);
          props.chart.ctx.lineTo(third.x, third.y - 5);
          props.chart.ctx.fillStyle = "#474747";
          props.chart.ctx.strokeStyle = "#474747";
          props.chart.ctx.fill();
          props.chart.ctx.stroke();

          props.chart.ctx.fillStyle = "#ffffff";
          props.chart.ctx.font =
            i18next.language === "de"
              ? "normal 12px Open Sans"
              : "normal 13px Open Sans";
          i18next.language === "en"
            ? props.chart.ctx.fillText(text[1], third.x - 29, third.y - 27)
            : i18next.language === "fr"
            ? props.chart.ctx.fillText(text[1], third.x - 32, third.y - 28)
            : i18next.language === "de"
            ? props.chart.ctx.fillText(text[1], third.x - 42, third.y - 28)
            : i18next.language === "pt"
            ? props.chart.ctx.fillText(text[1], third.x - 28, third.y - 28)
            : props.chart.ctx.fillText(text[1], third.x - 22, third.y - 28);

          props.chart.ctx.fillText(text[2], third.x - 30, third.y - 15);
        }
      },
      onProgress: function (props) {
        if (props.currentStep >= 1000) {
          const bars = props.chart.getDatasetMeta(0).data;
          const first = bars[0];
          props.chart.ctx.beginPath();
          i18next.language === "en"
            ? props.chart.ctx.roundRect(first.x - 35, first.y - 29, 70, 18, 2)
            : props.chart.ctx.roundRect(first.x - 37, first.y - 29, 75, 18, 2);
          props.chart.ctx.fillStyle = "#474747";
          props.chart.ctx.strokeStyle = "#474747";
          i18next.language === "en"
            ? props.chart.ctx.fillRect(first.x - 35, first.y - 29, 70, 18)
            : props.chart.ctx.fillRect(first.x - 37, first.y - 29, 75, 18);
          props.chart.ctx.stroke();

          props.chart.ctx.beginPath();
          props.chart.ctx.moveTo(first.x, first.y - 5);
          props.chart.ctx.lineTo(first.x + 5, first.y - 10);
          props.chart.ctx.lineTo(first.x - 5, first.y - 10);
          props.chart.ctx.lineTo(first.x, first.y - 5);
          props.chart.ctx.fillStyle = "#474747";
          props.chart.ctx.strokeStyle = "#474747";
          props.chart.ctx.fill();
          props.chart.ctx.stroke();

          props.chart.ctx.fillStyle = "#ffffff";
          i18next.language === "en"
            ? (props.chart.ctx.font = "normal 13px Open Sans")
            : (props.chart.ctx.font = "normal 12px Open Sans");
          i18next.language === "en"
            ? props.chart.ctx.fillText(text[0], first.x - 27, first.y - 16)
            : i18next.language === "de"
            ? props.chart.ctx.fillText(text[0], first.x - 25, first.y - 16)
            : i18next.language === "pt"
            ? props.chart.ctx.fillText(text[0], first.x - 22, first.y - 16)
            : props.chart.ctx.fillText(text[0], first.x - 32, first.y - 16);
        }
        if (props.currentStep >= 2000) {
          const bars = props.chart.getDatasetMeta(0).data;

          const third = bars[2];

          i18next.language === "de"
            ? props.chart.ctx.roundRect(third.x - 45, third.y - 40, 85, 30, 2)
            : props.chart.ctx.roundRect(third.x - 40, third.y - 40, 80, 30, 2);
          props.chart.ctx.fillStyle = "#474747";
          props.chart.ctx.strokeStyle = "#474747";
          i18next.language === "de"
            ? props.chart.ctx.fillRect(third.x - 45, third.y - 40, 85, 30)
            : props.chart.ctx.fillRect(third.x - 40, third.y - 40, 80, 30);
          props.chart.ctx.stroke();

          props.chart.ctx.beginPath();
          props.chart.ctx.moveTo(third.x, third.y - 5);
          props.chart.ctx.lineTo(third.x + 5, third.y - 10);
          props.chart.ctx.lineTo(third.x - 5, third.y - 10);
          props.chart.ctx.lineTo(third.x, third.y - 5);
          props.chart.ctx.fillStyle = "#474747";
          props.chart.ctx.strokeStyle = "#474747";
          props.chart.ctx.fill();
          props.chart.ctx.stroke();

          props.chart.ctx.fillStyle = "#ffffff";
          props.chart.ctx.font =
            i18next.language === "de"
              ? "normal 12px Open Sans"
              : "normal 13px Open Sans";

          i18next.language === "en"
            ? props.chart.ctx.fillText(text[1], third.x - 29, third.y - 27)
            : i18next.language === "fr"
            ? props.chart.ctx.fillText(text[1], third.x - 32, third.y - 28)
            : i18next.language === "de"
            ? props.chart.ctx.fillText(text[1], third.x - 42, third.y - 28)
            : i18next.language === "pt"
            ? props.chart.ctx.fillText(text[1], third.x - 28, third.y - 28)
            : props.chart.ctx.fillText(text[1], third.x - 22, third.y - 28);
          props.chart.ctx.fillText(text[2], third.x - 30, third.y - 15);
        }
      },
      delay: (context) => {
        let delay = context.dataIndex * 500;
        return delay;
      },
    },
    layout: {
      padding: {
        left: 20,
        right: 20,
        top: 20,
        bottom: 0,
      },
    },
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },

    scales: {
      x: {
        display: true,
        grid: {
          display: false,
        },
      },
      y: {
        display: false,
      },
    },
  };

  return <Bar data={data} options={options} plugins={[horizontalDottedLine]} />;
};

export default PersonalPlanChart;
